module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_6-9d64be5194727d11a43737794e5151a0.jpg";